import { Component, OnInit, ViewChild } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { ApiservicesService } from 'src/app/apiservices.service';
import { formatDate } from '@angular/common';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { UserTopComponent } from '../../../components/user-top/user-top.component';
import { EncryptdecryptService } from '../../../services/encryptdecrypt.service';




@Component({
  providers: [UserTopComponent],
  selector: 'app-penerimaan-pelantikan-permohonan-online',
  templateUrl: './penerimaan-pelantikan-permohonan-online.component.html',
  styleUrls: ['./penerimaan-pelantikan-permohonan-online.component.css']
})
export class PenerimaanPelantikanPermohonanOnlineComponent implements OnInit {
  //Session Variables
  SessionFirmID: any = "";
  SessionParams: any = "";
  SessionStaffID: any = "";

  //UI Input Variables
  SearchTypeInput: any = "";
  ValueInput: any = "";

  //UI View Alert Variables
  AlertType: string = "";
  AlertStatus: boolean = false;
  AlertMessage: string = "";

  //UI Status Variables
  LoaderStatus: boolean = false;
  NewStatus: boolean = false;
  ProcessedStatus: boolean = false;
  RejectedStatus: boolean = false;

  //UI Data Variables
  DataIDType: any = "";
  DataIDNo: any = "";


  //UI Datatable Variables
  @ViewChild(MatPaginator)
  paginator!: MatPaginator;
  dataSourceNew = new MatTableDataSource();
  dataSourceApproved = new MatTableDataSource();
  dataSourceRejectedORCancelled = new MatTableDataSource();
  displayedColumns = ['taxpayername', 'taxpayeridno', 'taxpayertin', 'datereq', 'taxagent','action'];
  displayedProcessedColumns = ['taxpayername', 'taxpayeridno', 'taxpayertin', 'datereq','taxagent', 'approvedate', 'actionby', 'action'];
  displayedRejectedColumns = ['taxpayername', 'taxpayeridno', 'taxpayertin', 'dateReq', 'taxagent', 'approvedate', 'actionby', 'status', 'action'];
  totalRecord: any = 0;

  //UI Pagination Variables
  pageNumGlobal: any = 0;
  pageSizeGlobal: any = 10;
  pageNumNewGlobal: any = 0;
  pageNumProcessedGlobal: any = 0;
  pageNumRejectedGlobal: any = 0;
  pageSizeNewGlobal: any = 10;
  pageSizeProcessedGlobal: any = 10;
  pageSizeRejectedGlobal: any = 10;

  constructor(private router: Router, private apiServices: ApiservicesService, private top: UserTopComponent, private encryptDecryptService: EncryptdecryptService) { }

  async ngOnInit(): Promise<void> {
    this.top.updateTotal();
    this.SessionFirmID = this.encryptDecryptService.decrypt(sessionStorage.getItem('FirmID') || '');
    this.SessionStaffID = this.encryptDecryptService.decrypt(sessionStorage.getItem('StaffID') || '');
    this.SessionParams = sessionStorage.getItem('tempParams');
    this.SessionParams = JSON.parse(this.SessionParams);
    var pageNumLocal = 0;
    var pageSizeLocal = 10;
    if (this.SessionParams == null) {
      this.NewStatus = true;
      this.ProcessedStatus = false;
      this.RejectedStatus = false;
      this.GetAppointedParams("","","Baharu");
    } else {
      var status = await this.apiServices.GetEncryptDecrypt("202", this.SessionParams.status);
      var idtype = this.SessionParams.IDType === "" ? "" : await this.apiServices.GetEncryptDecrypt("202", this.SessionParams.IDType);
      var idno = this.SessionParams.IDNo === "" ? "" : await this.apiServices.GetEncryptDecrypt("202", this.SessionParams.IDNo);
      if (status === "Baharu") {
        this.NewStatus = true;
        this.ProcessedStatus = false;
        this.RejectedStatus = false;
        this.pageNumNewGlobal = this.SessionParams.pageNum;
        this.pageSizeNewGlobal = this.SessionParams.pageSize;
      } else if (status === "Diluluskan") {
        this.NewStatus = false;
        this.ProcessedStatus = true;
        this.RejectedStatus = false;
        this.pageNumProcessedGlobal = this.SessionParams.pageNum;
        this.pageSizeProcessedGlobal = this.SessionParams.pageSize;
      } else if (status === "Ditolak") {
        this.NewStatus = false;
        this.ProcessedStatus = false;
        this.RejectedStatus = true;
        this.pageNumRejectedGlobal = this.SessionParams.pageNum;
        this.pageSizeRejectedGlobal = this.SessionParams.pageSize;
      }
      this.SearchTypeInput = idtype;
      this.ValueInput = idno;
      pageNumLocal = this.SessionParams.pageNum;
      pageSizeLocal = this.SessionParams.pageSize;
      if (idtype == "")
        this.GetAppointedParams("", "", status);
      else
        this.GetAppointedParams(idtype, idno, status);
      //this.GetData(this.SessionFirmID, status, "", "", pageNumLocal, pageSizeLocal);
    }
    sessionStorage.removeItem('tempParams');
    this.SessionParams = null;
  }
  async TabChange(Status: any) {
    this.SearchTypeInput = "";
    this.ValueInput = "";
    let Params = {
      "FirmID": this.SessionFirmID,
      "Status": Status,
      "StaffID": this.SessionStaffID,
      "PageNum": this.pageNumGlobal,
      "PageSize": this.pageSizeGlobal
    }
    await this.GetData(Params);
  }
  async GetAppointedParams(IDType: any, IDNo: any, Status: any) {
    //this.SearchTypeInput = "";
    //this.ValueInput = "";
    let Params = {};
    if (IDType === "") {
      Params = {
        "FirmID": Number(this.SessionFirmID),
        "Status": Status,
        "StaffID": Number(this.SessionStaffID),
        "PageNum": this.pageNumGlobal,
        "PageSize": this.pageSizeGlobal
      }
    } else {
      Params = {
        "FirmID": Number(this.SessionFirmID),
        "Status": Status,
        "StaffID": Number(this.SessionStaffID),
        "IDType": Number(IDType),
        "IDNo": String(IDNo),
        "PageNum": this.pageNumGlobal,
        "PageSize": this.pageSizeGlobal
      }
    }
    await this.GetData(Params);
  }
  async GetData(Params: any) {
    this.LoaderStatus = true;
    const result = await this.apiServices.GetLantikanByStatus(Params);
    if (result.hasError) {
      this.dataSourceNew = new MatTableDataSource();
      this.totalRecord = 0;
      this.LoaderStatus = false;
    } else {
      result.records.forEach((currentValue: any, index: any) => {
        result.records[index].remarks = (result.records[index].remarks == null || result.records[index].remarks == "") ? "N/A" : result.records[index].remarks;
        result.records[index].requestDate = (result.records[index].requestDate == null || result.records[index].requestDate == "") ? "N/A" : formatDate(result.records[index].requestDate, 'dd-MMM-yyyy h:mm:ss a', "en-US");
        result.records[index].actionDate = (result.records[index].actionDate == null || result.records[index].actionDate == "") ? "N/A" : formatDate(result.records[index].actionDate, 'dd-MMM-yyyy h:mm:ss a', "en-US");
        result.records[index].revokeDate = (result.records[index].revokeDate == null || result.records[index].revokeDate == "") ? "N/A" : formatDate(result.records[index].revokeDate, 'dd-MMM-yyyy h:mm:ss a', "en-US");
        result.records[index].busRegistNo = (result.records[index].busRegistNo == null || result.records[index].busRegistNo.replace(/\s/g, "") == "") ? "N/A" : result.records[index].busRegistNo;
      });
      this.dataSourceNew = new MatTableDataSource(result.records);
      this.totalRecord = result.totalRecord;
      this.LoaderStatus = false;
    }
  }
  async GotoDetailPage(LantikanID: any, status: any) {
    const resultID = await this.apiServices.GetEncryptDecrypt("201", LantikanID);
    const resultStatus = await this.apiServices.GetEncryptDecrypt("201", status);
    const resultIDType = this.DataIDType === "" ? "" : await this.apiServices.GetEncryptDecrypt("201", this.DataIDType);
    const resultIDNo = this.DataIDNo === "" ? "" : await this.apiServices.GetEncryptDecrypt("201", this.DataIDNo);
    let tempParams = {
      LantikanID: resultID,
      status: resultStatus,
      IDType: resultIDType,
      IDNo: resultIDNo,
      pageNum: this.pageNumGlobal,
      pageSize: this.pageSizeGlobal
    };
    sessionStorage.removeItem('tempParams');
    sessionStorage.setItem('tempParams', JSON.stringify(tempParams));
    this.router.navigate(['/butiran-penerimaan-pelantikan-online']);
  }
  async paginatorEvent(e: PageEvent, Status: any) {
    this.LoaderStatus = true;
    this.pageNumGlobal = e.pageIndex;
    this.pageSizeGlobal = e.pageSize;
    let Params = {
      "FirmID": this.SessionFirmID,
      "Status": Status,
      "StaffID": this.SessionStaffID,
      "PageNum": e.pageIndex,
      "PageSize": e.pageSize
    }
    await this.GetData(Params);
  }
  async SubmitFilter(IDType: any, IDNo: any, Status:any) {
    this.LoaderStatus = true;
    if (IDType === "" || IDNo === "") {
      this.AlertType = "fail";
      this.AlertMessage = "Sila masukkan butiran";
      this.AlertStatus = true;
      setTimeout(() => {
        this.AlertStatus = false;
      }, 1001);
      this.LoaderStatus = false;
    } else {
      this.DataIDType = IDType;
      this.DataIDNo = IDNo;
      this.dataSourceNew.paginator = this.paginator;
      this.pageNumGlobal = 0;
      this.pageSizeGlobal = 10;
      this.GetAppointedParams(IDType, IDNo,Status);
    }
  }
  async ClearFilter(Status: any) {
    this.SearchTypeInput = "";
    this.ValueInput = "";
    this.GetAppointedParams("", "", Status);
  }
}
